<template>
  <div class="c-text-img">
    <div class="c-text-img__text">
      <paragraph :wording="wording" />
    </div>
    <div class="c-text-img__img">
      <single-img v-bind="imgOption" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Paragraph from './Paragraph.vue';
import SingleImg from '@/components/Global/SingleImg.vue';
import burpImg from '@/assets/img/resource/burp.png';

export default defineComponent({
  name: 'TextImg',
  props: {
    wording: {
      type: Array,
      default: () => [],
    },
    imgOption: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Paragraph, SingleImg },
  setup() {
    return {
      burpImg,
    };
  },
});
</script>
<style lang="scss" scoped>

@media screen and (min-width: $portrait) {
  .c-text-img {
  @include flex(space-between);

  &__text {
    flex: 1;
  }

  &__img {
    flex: none;
    min-width: 50px;
    margin-left: 30px;
  }
}
}
</style>
